<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Instruktur
      <template v-if="role_status && role_status.status_create">
        <router-link to="/pelatihan/instruktur/tambah" class="ml-auto">
          <CButton color="success" class="btn-md">Tambah</CButton>
        </router-link>
      </template>
    </CCardHeader>
    <!-- Data Workshop -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index }">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #namaInstruktur="{item }">
              <td
                class="py-2"
              >{{ item.namaInstruktur == null || item.namaInstruktur == "null" ? '-' : item.namaInstruktur }}</td>
            </template>
            <template #npwp="{ item }">
              <td class="py-2">{{ item.npwp == "null" || item.npwp == null ? '-' : item.npwp }}</td>
            </template>
            <template #noTelepon="{item }">
              <td
                class="py-2"
              >{{ item.noTelepon == null || item.noTelepon == "null" ? '-' : item.noTelepon }}</td>
            </template>
            <template #email="{item }">
              <td class="py-2">{{ item.email == null || item.email == "null" ? '-' : item.email }}</td>
            </template>
            <template #instansi="{item }">
              <td
                class="py-2"
              >{{ item.instansi == null || item.instansi == "null" ? '-' : item.instansi }}</td>
            </template>
            <template #tipeInstruktur="{ item }">
              <td
                class="py-2"
              >{{ item.tipeInstruktur ? item.tipeInstruktur: '-' }}</td>
            </template>
            <template #cv="{ item }">              
              <td>
                <button @click="bukaFile(item.cv)" :class="item.cv == '' || item.cv == null? 'btn btn-secondary p-0 px-3 mx-auto' : 'btn btn-success p-0 px-3 mx-auto'" type="button" :disabled="item.cv == '' || item.cv == null">
                  {{ item.cv == null || item.cv == "null" ? 'File tidak ada' : 'Lihat file' }}
                </button>
              </td>              
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                <router-link
                  :to="'/pelatihan/instruktur/edit/'+item.idInstruktur"
                >
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mr-2" square>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data provinsi -->
  </CCard>
</template>
<script>
import InstrukturService from "../../../services/pelatihan/instruktur.service";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { Pagination } from "../../../mixins/Pagination";
import Utils from "@/services/utils.service";
import BaseUrl from "@/services/base-url";
const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "namaInstruktur",
    label: "Nama Instruktur",
    sorter: true,
    filter: false
  },
  {
    key: "npwp",
    label: "NPWP",
    sorter: true,
    filter: false
  },
  {
    key: "noTelepon",
    label: "Nomor Telepon",
    sorter: true,
    filter: false
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false
  },
  {
    key: "instansi",
    label: "Instansi",
    sorter: true,
    filter: false
  },
  {
    key: "cv",
    label: "Dokumen CV",
    sorter: true,
    filter: false
  },
  {
    key: "status",
    label: "Status Aktif",
    _style: "text-align: center",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils, Pagination],
  data() {
    return {
      items: [],
      BaseUrl: "",
      formData: {
        idInstruktur: "",
        idAnggota: "",
        tipeInstruktur: "",
        email: "",
        noTelepon: "",
        namaInstruktur: "",
        instansi: "",
        npwp: "",
        alamat: "",
        cv: "",
        status: "",
        fileName: ""
      },
      fileName: "Choose File...",
      fields,
      details: [],
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed : 0,
      role_status: null
    };
  },
  mounted() {
    this.roleData();
    this.getData("0", this.pageSize, this.search);
    this.baseUrl = BaseUrl();
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    pageChange() {
      this.getData(currentPage);
    },

    getData(currentPage, pageSize, filter) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      InstrukturService.getInstruktur(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();

          vm.items = response.data.data.content;          

          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber +1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    deleteData(item) {
      var vm = this;
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            InstrukturService.deleteInstruktur(this.formData)
              .then(response => {
                // comment console console.log(response);

                vm.alertDeleteSuccess();

                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                vm.alertError(error.response.data.message);
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    bukaFile(file) {
      
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=pelatihan@instruktur@cv";
        window.open(routeData, "_blank");
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },
  }
};
</script>